import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { AppState } from '../../app.service';
import { PermissionService } from "./permission.service";
import { Observable } from "rxjs/Observable";
import { BaseGuard } from "./base.guard";

@Injectable()
export class ViewSiteGuard extends BaseGuard {

    constructor(
        private permissionService: PermissionService,
        private router: Router,
        private appState: AppState
    ) {
        super(permissionService, 'View_Site', router, appState);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/SecurityServices/view-site.guard.ts